import React, {Component} from "react";
import {ASSET_BASE_URL} from "../../../../configs/website";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from "swiper";
import 'swiper/swiper.css';
import Ink from "react-ink";
import {Link} from "react-router-dom";
// import $ from 'jquery';
/*import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';*/

class PromoSlider extends Component {

	componentDidUpdate(prevProps, prevState, snapshot) {
		// React.initializeTouchEvents(true);
	}

	render() {
		const { slides, size, secondarySlider, slide_per_view, slide_gap } = this.props;


		return (



			<React.Fragment>

				<div className={
					secondarySlider
						? "slider-wrapper secondary-slider-wrapper"
						: "slider-wrapper bg-light"
				}>
					<Swiper
						// install Swiper modules
						modules={[Autoplay]}
						spaceBetween={parseInt(slide_gap)}
						slidesPerView={parseFloat(slide_per_view)}
						navigation
						// pagination={{ clickable: true }}
						autoplay={true}
						scrollbar={{ draggable: true }}
						// onSwiper={(swiper) => console.log(swiper)}
						// onSlideChange={() => console.log('slide change')}
					>
						{slides.map((slide) => (
							<SwiperSlide key={slide.data.id} style={{height: "auto"}}>
								<div  className='' style={{ borderRadius: "5px"}}>
									<div className={`slide-item`}>
										<Link
											to={slide.url}
											className="slider-wrapper__img-wrapper"
											key={slide.data.id}
											style={{ width: "100%", position: "relative" }}
										>
											<img style={{boxShadow: "rgb(0 0 0 / 1%) 0px 3px 6px, rgb(0 0 0 / 7%) 0px 3px 6px", borderRadius: "5px", height: "auto", width:"100%"}} data-src={ASSET_BASE_URL + slide.data.image} src={ASSET_BASE_URL + slide.data.image} alt={`slider`} />
											<Ink duration="500" hasTouch={true} />
										</Link>
										{/*<img src={ASSET_BASE_URL + slide.data.image}/>*/}
									</div>
								</div>
							</SwiperSlide>
						))}
						{/*...*/}
					</Swiper>
				</div>
			</React.Fragment>
		);
	}
}

export default PromoSlider;
